import React from 'react';
import IconWithText from 'components/Widgets/IconWithText';

import { Button } from 'react-bootstrap5';

import { useContext } from 'components/Members/Onboarding/Context';

import StartTalentAssessmentGeneral from './StartTalentAssessmentGeneral';
import StartTalentAssessmentReturnToWork from './StartTalentAssessmentReturnToWork';

export default function StartTalentAssessment() {
  const { dispatch, state, actions } = useContext();

  const onGoNextClick = () => {
    actions.completeStep(state.steps[state.currentStep].step, () => {
      actions.setNextStep({
        dispatch,
        steps: state.steps,
        isPossibleSkip: false,
        currentStep: state.currentStep,
      });
    });
  };

  return (
    <div className="content onboarding-content">
      <div className="row">
        <div className="col-lg order-lg-last">
          <div className="bg-photo bg-members-onboarding-cpa-intro-photo" />
        </div>
        <div className="col-lg order-lg-first">
          <div className="pt-4 p-sm-4 pe-lg-0 h-100 d-flex flex-column">
            {state.workflow === 'RETURN_TO_WORK_ONBOARDING'
              ? <StartTalentAssessmentReturnToWork />
              : <StartTalentAssessmentGeneral />}

            <p>Let’s get started!</p>
            <IconWithText
              iconClassName="big-icon privacy-by-design-icon bg-secondary"
              wrapperClassName="mb-3"
            >
              <h6>Privacy By Design</h6>
              <small>Your answers are 100% confidential</small>
            </IconWithText>
            <IconWithText
              iconClassName="big-icon honesty-icon bg-secondary"
              wrapperClassName="mb-3"
            >
              <h6>Be authentic!</h6>
              <small>Your natural responses provide the most valuable insights</small>
            </IconWithText>
            <div className="mt-auto">
              <Button
                onClick={onGoNextClick}
                className="d-block d-sm-inline-block mt-4 mt-sm-3"
              >
                Start
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
